import React from "react";
import { Button, OverlayTrigger, Popover, Table } from "react-bootstrap";
import { Employee } from "../types/Employee";
import { useNavigate } from "react-router-dom";
import { apiUrl } from "../config";
import "../styles/EmployeeList.css";
import { Eye, Paperclip, Edit, Trash } from "lucide-react";
import { useSelector } from "react-redux";
import { StoreState } from "../redux/reducers";

type Props = {
  employeeList: Employee[];
  onEdit: (employee: Employee) => void;
  onDelete: (id: number) => void;
  onView: (employee: Employee) => void;
};

const EmployeeList: React.FC<Props> = ({
  employeeList,
  onEdit,
  onDelete,
  onView,
}) => {
  console.log("Employee List", employeeList);
  const employees = useSelector((state: StoreState) => state.employee);

  const navigate = useNavigate();

  const handleAttachment = (employeeId: string) => {
    navigate(`/employee_attachment/${employeeId}`);
  };

  const viewPopover = (
    <Popover id="popover-view">
      <Popover.Body>View employee details</Popover.Body>
    </Popover>
  );

  const attachmentPopover = (
    <Popover id="popover-attachment">
      <Popover.Body>Attach documents</Popover.Body>
    </Popover>
  );
  return (
    <>
      <Table className="custom-employee-table" responsive>
        <thead>
          <tr>
            <th>S.No</th>
            <th>ID</th>
            <th>Name</th>
            <th>Photo</th>
            <th>Email</th>
            <th>Role</th>
            <th>Mobile</th>
            <th>DOB</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {employeeList.map((emp, index) => (
            <tr key={emp.id}>
              <td>{index + 1}</td>
              <td>{emp.employeeId}</td>
              <td>{emp.name}</td>
              <td>
                <img
                  src={apiUrl + "/" + emp.photoUrl}
                  alt={emp.name}
                  className="student-thumbnail"
                  style={{
                    objectFit: "contain",
                    height: "70px",
                    width: "70px",
                  }}
                />
              </td>
              <td>{emp.emailId}</td>
              <td>{emp.role}</td>
              <td>{emp.mobileNumber}</td>
              <td>{emp.birhDate}</td>
              <td>{emp.status}</td>
              <td className="d-flex mt-2">
                <OverlayTrigger
                  trigger={["hover", "focus"]}
                  placement="top"
                  overlay={viewPopover}
                >
                  <Button
                    className="btn btn-sm text-white ms-2"
                    style={{
                      backgroundColor: "#10296C",
                      padding: "5px",
                      borderRadius: "5px",
                      marginRight: "5px",
                    }}
                    onClick={() => onView(emp)}
                  >
                    <Eye style={{ width: "20px" }} />
                  </Button>
                </OverlayTrigger>
                <OverlayTrigger
                  trigger={["hover", "focus"]}
                  placement="top"
                  overlay={attachmentPopover}
                >
                  <Button
                    variant="success"
                    className="btn btn-sm text-white bg-success"
                    style={{
                      backgroundColor: "#10296C",
                      padding: "5px",
                      borderRadius: "5px",
                      marginRight: "5px",
                    }}
                    onClick={() => handleAttachment(emp.employeeId)}
                  >
                    <Paperclip style={{ width: "20px" }} />
                  </Button>
                </OverlayTrigger>
                <Button
                  variant="warning"
                  className="mr-2"
                  onClick={() => onEdit(emp)}
                  style={{
                    padding: "5px",
                    borderRadius: "5px",
                  }}
                >
                  <Edit />
                </Button>
                {/* <Button
                variant="danger"
                onClick={() => onDelete(emp.id)}
                style={{
                  padding: "5px",
                  borderRadius: "5px",
                }}
              >
                <Trash />
              </Button> */}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

export default EmployeeList;
